import React, { useState } from "react";
import axios from "axios";
import CategoryConversion from "./categoryConversion";
import CompanyDetailsForm from "./companyDetailsForm";

const RegistrationFlow = () => {
  const [step, setStep] = useState(1); 
  const [verifiedData, setVerifiedData] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [error, setError] = useState("");

  // -------------------- API 1: Verify Barcode + Mobile --------------------
  const handleVerified = async (data) => {
    try {
      setError("");

      const res = await axios.post(
        `${process.env.REACT_APP_APPROVALAPI_END_POINT}/verify-barcode`,
        {
          barcode: data.barcode,
          mobile: data.mobile,
        }
      );

      if (res.data.status === true) {
        setVerifiedData(data);
        setStep(2); // move to company details form
      } else {
        setError(res.data.message || "Verification failed.");
      }
    } catch (err) {
      setError(err.response.data.message || "Server error during verification.");
    }
  };

  // -------------------- API 2: Submit Company Details --------------------
  const handleCompanySubmit = async (data) => {
    try {
      setError("");

      const formData = new FormData();
      formData.append("barcode", verifiedData.barcode);
      formData.append("mobile", verifiedData.mobile);

      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });

      const res = await axios.post(
        `${process.env.REACT_APP_APPROVALAPI_END_POINT}/submit-company-details`,
        formData
      );

      if (res.data.status === true) {
        setCompanyData(data);
        setStep(3);
        return true; // ✅ IMPORTANT
      } else {
        setError(res.data.message || "Submission error");
        throw new Error("Submission failed");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error while submitting details.");
      throw err; // ✅ IMPORTANT
    }
  };


  return (
    <div style={styles.wrapper}>

      {/* Show API Error Globally */}
      {error && <h6 style={{ color: "red", textAlign: "center" }}>{error}</h6>}

      {step === 1 && (
        <CategoryConversion onVerified={handleVerified} />
      )}

      {step === 2 && (
        <CompanyDetailsForm 
          barcode={verifiedData.barcode}
          onSubmitCompany={handleCompanySubmit} 
        />
      )}

      {step === 3 && <WaitingForApprovalScreen />}
    </div>
  );
};

export default RegistrationFlow;

// ---------------- Waiting Screen ----------------
const WaitingForApprovalScreen = () => {
  return (
    <div style={styles.waitScreen}>
      <h2>Thank You!</h2>
      <p>Your details have been submitted successfully.</p>
      <p><strong>Please wait for approval... You will receive a message once approved.</strong></p>   
    </div>
  );
};

// ------------------ Styles ------------------
const styles = {
  wrapper: {
    width: "100%",
    maxWidth: "600px",
    margin: "auto",
    marginTop: "20px",
    padding: "20px",
    fontFamily: "Arial",
  },
  waitScreen: {
    textAlign: "center",
    paddingTop: "40px",
  },
};
